import { jsx, jsxs } from "react/jsx-runtime";
import { Tooltip } from "antd";
import { TiLocale } from "../../types";
import useTiMaxStore from "../../hooks/useTiMaxStore";
import useStyles from "./style";
const SwitchLocale = ({ onChange }) => {
  const { styles } = useStyles();
  const { locale, setLocale } = useTiMaxStore();
  const isCN = locale === TiLocale.ZH_CN;
  const switchFn = () => {
    setLocale(locale === TiLocale.ZH_CN ? TiLocale.EN_US : TiLocale.ZH_CN);
    onChange == null ? void 0 : onChange();
  };
  const localeOrder = isCN ? ["\u4E2D", "EN"] : ["EN", "\u4E2D"];
  const tooltipTitle = "\u4E2D\u6587 / English";
  return /* @__PURE__ */ jsx(Tooltip, { title: tooltipTitle, children: /* @__PURE__ */ jsxs("div", { className: styles.btn, onClick: switchFn, children: [
    /* @__PURE__ */ jsx("div", { children: localeOrder[0] }),
    /* @__PURE__ */ jsx("div", { children: localeOrder[1] })
  ] }) });
};
var SwitchLocale_default = SwitchLocale;
export {
  SwitchLocale_default as default
};
